//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sanitizeHtml from 'sanitize-html';
import DpTable from './Table.vue';
import DpTableBody from './TableBody.vue';
import DpTableButtonCell from './TableButtonCell.vue';
import DpTableCell from './TableCell.vue';
import DpTableHead from './TableHead.vue';
import DpTableHeadCell from './TableHeadCell.vue';
import DpTableRow from './TableRow.vue';

export default {
  name: 'DpSimpleTable',
  components: {
    DpTable,
    DpTableHead,
    DpTableHeadCell,
    DpTableBody,
    DpTableRow,
    DpTableCell,
    DpTableButtonCell,
  },
  props: {
    data: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
    disabledKey: { type: String, default: () => null },
  },
  computed: {
    displayColumns() {
      return this.columns.filter((col) => col.key);
    },
    buttonsColumn() {
      let foundColumn = null;
      this.columns.forEach((col) => {
        if (col.buttons) {
          foundColumn = col;
        }
      });
      return foundColumn;
    },
  },
  methods: {
    getTemplate(column, row) {
      if (!column || !row) return null;

      if (column.allowHTML) {
        return sanitizeHtml(row[column.key], {
          allowedTags: ['p', 'span', 'b', 'strong', 'br'],
          allowedAttributes: {
            span: ['style'],
          },
        });
      }

      const datum = row[column.key];
      return datum || '';
    },
    handleAction(eventName, row) {
      this.$emit(eventName, row);
    },
    isDisabled(d) {
      if (!this.disabledKey) {
        return false;
      }
      return !!d[this.disabledKey];
    },
  },
};
